<template>
  <v-container>
    <loading-spinner v-if="loading"></loading-spinner>
    <template v-else>
      <v-row>
        <v-col cols="12" class="text-center">
          <h1>Create Customer</h1>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <create-customer-form
            v-on:save="$router.push({ path: '/portal/customers' })"
          ></create-customer-form>
        </v-col>
      </v-row>
    </template>
  </v-container>
</template>

<script>
import CreateCustomerForm from "@/components/portal/CreateCustomerForm";
export default {
  name: "CreateCustomer",
  components: { CreateCustomerForm },
  data: () => ({
    loading: false
  }),
  created() {
    this.loading = true;
    this.$store.dispatch("customer/resetCustomerAndProfile").finally(() => {
      this.loading = false;
    });
  }
};
</script>
